<div class="container u-mt60">
  <div class="row">
    <div class="col-12">
      <div class="breadcrumbs">
        <ul>
          <li>
            <a routerLink="/dashboard">
              Inicio
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="col-md-8">
      <h1 class="u-mb60 txt txt--title">
        Registrar infracción
      </h1>
    </div>
  </div>
</div>
<div class="bg--lightgrey u-pt50 u-pb70">
  <div class="container">
    <div class="row">
      <div class="col-md-8 offset-md-2">
        <div class="u-center">
          <img class="icon u-mb30" src="assets/img/icon-bad.png" alt="">
          <h2 class="u-mb30 txt txt--subtitle">
            Hubo un problema y no hemos podido registrar la infracción. Por favor intenta de nuevo.
          </h2>
          <a class="btn btn--link btn--link--secondary btn--link--secondary--big btn--link--secondary--bold btn--link--secondary--color mt-2 pl-0"
            routerLink="/infractions/enter">Crear una nueva infracción</a>
        </div>
      </div>
    </div>
  </div>
</div>
